module.exports = __webpack_public_path__ + "img/logo_footer.67d263f3.svg";